export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
